var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"html-viewer-container"},[_c('iframe',{ref:"htmlIframe",staticClass:"html-content-frame",attrs:{"sandbox":"allow-same-origin allow-scripts"},on:{"load":_vm.onIframeLoad}})])}
var staticRenderFns = []

export { render, staticRenderFns }